<template>
    <div
        class="inline-flex rounded border border-gray-300 overflow-hidden flex-shrink-0"
        role="radiogroup"
        :aria-label="label"
    >
        <button
            v-for="choice in choices"
            :key="choice"
            type="button"
            role="radio"
            :aria-checked="modelValue === choice"
            :class="[
                'px-2 py-0.5 text-xs border-l first:border-l-0 border-gray-300',
                'focus:outline-none focus:ring-2 focus:ring-inset focus:ring-minplan-blue',
                modelValue === choice
                    ? 'bg-minplan-blue text-white'
                    : 'bg-white text-gray-600 hover:bg-gray-50',
            ]"
            @click="$emit('update:modelValue', choice)"
        >
            {{ $t(`templateTransfer.decision.${choice}`) }}
        </button>
    </div>
</template>

<script>
import { defineComponent } from "vue";

// Plan vorlage-auf-wohnungen (Task 10): Übertragen / Offen lassen / Verwerfen.
// `modelValue === null` heisst «gemischt»: dann ist keine Wahl hervorgehoben.
export default defineComponent({
    props: {
        modelValue: { type: String, default: null },
        choices: { type: Array, default: () => ["apply", "keep", "discard"] },
        label: { type: String, default: "" },
    },
    emits: ["update:modelValue"],
});
</script>
